export interface Member {
  id: number;
  uniqueId?: string;
  clientId?: string;
  externalId?: string;
  accountBalance?: number;
  memberFullName?: string;
  memberFirstName: string;
  memberLastName: string;
  accessTypes: {
    isMobileAppDisabled: boolean;
    // isAccessCardDeativated: boolean;
    isJustTapRevoked: boolean;
  };

  signedupDate: string;
  status: string;
  phoneNumber: string;
  isBlocked: boolean;
  createdBy: number;
  createdDate: string;
  lastModifiedBy: number;
  lastModifiedDate: string;
  imageUrl: string;
  businessName?: string;
  memberWaiverStatus?: MemberWaiverStatus;
  memberWaiverAgreementDateTime?: string;
  memberWaiverGraceUntil?: string;
  email?: string;
  defaultLocationDetectionMethod?: string;
  lastSyncDate?: string;
  isTrial?: boolean;
  arxReferenceId?: string;
  userId?: number;
  linkedPhoneNumber?: string;
  hasAccessCard?: boolean;
  hasActiveWalletPass?: boolean;
  hasForcedAccess?: boolean;
  hasManualAccess?: boolean;
  hasLocationOverride?: boolean;
  displayHasForcedAccess?: string;
  displayHasManualAccess?: string;
  displayHasLocationOverride?: string;
  isFreepassMember?: boolean;
  displayIsFreepassMember?: string;
  memberLocationId: number;
  language: string;
  displayIsImported?: string;
  flag?: number;
}

export type MemberWaiverStatus = 'signed' | 'grace' | 'not-signed' | 'unknown';

export const parseMemberWaiverStatus = (status?: string | null): MemberWaiverStatus =>
  status === 'signed' || status === 'grace' || status === 'not-signed' ? status : 'unknown';

export interface MemberDetails {
  membership?: string;
  memberLocationMembershipId?: number;
  subscriptionDeleted?: boolean;
  validFrom?: string;
  validTo?: string;
  subscriptionCreatedDate?: string;
  subscriptionModifiedDate?: string;
  subscriptionIsSelected?: string;
  subscriptionStatus?: string;
  scheduleType?: string;
  remainingSessions?: number;
  siteLocationMembershipStatus?: string;
}

export interface MemberBookingDetails {
  booking?: string;
  importedId?: number;
  appointmentId?: number;
  isVisited?: string;
  startDateTime?: string;
  endDateTime?: string;
  createdDate?: string;
  lastModifiedDate?: string;
  membershipName?: string;
  siteLocation?: string;
  isDeleted?: string;
}

export interface MemberAccessCard {
  memberId: number;
  userId: number;
  arxReferenceId?: string;
  firstName: string;
  lastName: string;
  hasAccessCard: boolean;
  imageUrl: string;
}

export interface MemberAccessMethodsTable {
  accessCardUID?: string;
  mobileAppId?: number;
  createdDate?: string;
  createdBy?: number;
  lastModifiedDate?: string;
  lastModifiedBy?: number;
  status: string;
  type: string;
}
export interface MemberChangePhoneNumberFormInput {
  phoneNumber: string;
  countryCode: string;
}
